import { FaTimesCircle, FaPlus } from "react-icons/fa";
import DiffViewer from "../common/DiffViewer";
import VersionMenu from "./VersionMenu";

const FragmentDetailsModal = ({
  fragment,
  onClose,
  loadingVersions,
  fragmentVersions,
  selectedVersion,
  onVersionSelect,
  fragmentsInUse,
  viewingHistorical,
  showDiff,
  setShowDiff,
  selectedVersionContent,
  getComparisonContent,
  getComparisonVersionNumber,
  getSelectedVersionNumber,
  getAddButtonText,
  onAddFragmentToPrompt,
}) => {
  if (!fragment) return null;

  const selectedVersionObject = fragmentVersions.find(
    (v) => v.id === selectedVersion
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-800 text-white rounded-lg shadow-lg w-4/5 max-w-4xl max-h-screen overflow-y-auto">
        <div className="flex justify-between items-center p-4 border-b border-gray-700">
          <h2 className="text-xl font-semibold">
            {fragment.name || "Unnamed Fragment"}{" "}
            <span className="font-mono text-gray-400 text-lg">
              ({fragment.block_name})
            </span>
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <FaTimesCircle className="text-xl" />
          </button>
        </div>

        <div className="p-4">
          {fragment.description && (
            <div className="mb-4">
              <label className="block text-gray-400 mb-1">Description</label>
              <div className="bg-gray-700 p-2 rounded text-white">
                {fragment.description}
              </div>
            </div>
          )}

          {loadingVersions ? (
            <div className="flex justify-center items-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
            </div>
          ) : (
            <>
              {fragmentVersions.length > 0 && (
                <VersionMenu
                  fragmentVersions={fragmentVersions}
                  selectedVersion={selectedVersion}
                  onVersionSelect={onVersionSelect}
                  fragmentsInUse={fragmentsInUse}
                  selectedFragment={fragment}
                  viewingHistorical={viewingHistorical}
                />
              )}

              {viewingHistorical && (
                <div className="mt-1 flex justify-end">
                  <button
                    onClick={() => setShowDiff(!showDiff)}
                    className="text-blue-400 text-sm hover:underline flex items-center"
                  >
                    {showDiff
                      ? "Hide Comparison"
                      : "Show Side-by-Side Comparison"}
                  </button>
                </div>
              )}

              {showDiff && fragmentVersions.length > 0 ? (
                <div>
                  <label className="block text-gray-400 mb-1">
                    {fragmentsInUse && fragmentsInUse[fragment?.id]
                      ? `Changes compared to version in use (v${
                          fragmentsInUse[fragment.id]
                        })`
                      : "Changes compared to latest version"}
                  </label>
                  <DiffViewer
                    oldContent={getComparisonContent()}
                    newContent={selectedVersionContent}
                    selectedVersionNumber={getComparisonVersionNumber()}
                    comparisonVersionNumber={getSelectedVersionNumber()}
                  />
                </div>
              ) : (
                <div>
                  <label className="block text-gray-400 mb-1">Content</label>
                  <textarea
                    className="w-full bg-gray-700 text-white p-2 rounded font-mono h-64 resize-none"
                    readOnly
                    value={selectedVersionContent}
                  />
                </div>
              )}

              {selectedVersionObject && (
                <div className="mt-4 text-sm text-gray-400 border-t border-gray-700 pt-3">
                  <div className="flex justify-between items-center">
                    <div className="space-y-1">
                      <div>
                        {selectedVersionObject.updated_at
                          ? new Date(
                              selectedVersionObject.created_at
                            ).toLocaleString()
                          : "Unknown date"}
                      </div>
                      <div>
                        Updated by{" "}
                        <span className="text-white">
                          {selectedVersionObject.updated_by || "Unknown user"}
                        </span>
                      </div>
                    </div>

                    <button
                      onClick={() =>
                        onAddFragmentToPrompt(
                          fragment,
                          getSelectedVersionNumber()
                        )
                      }
                      className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded flex items-center"
                    >
                      <FaPlus className="mr-2" />
                      {getAddButtonText(fragment, getSelectedVersionNumber())}
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FragmentDetailsModal;
